// @ vendors
const { Promise } = require('es6-promise');
const { get, has } = require('lodash');

// @ commons
const { APIPost, APIGet, base64ToBlob, downloadAsFile } = require('utilities/APIRequestHelper');
const BrowserUtils = require('utilities/browserUtils');
const getExtension = require('utilities/mimeTypeToExt');
const { getLanguage } = require('core/i18n').i18n;

// @ actions
const { fetchAmmounts } = require('actions/mortgageRequest/mortgageRequestEstates');
const { requestDataProprietor } = require('actions/mortgageRequest/mortgageRequestDataProprietor');
const { requestSummaryDocumentation } = require('actions/mortgageRequest/mortgageRequestDataProprietor');
const { requestInmuebles } = require('actions/mortgageRequest/mortgageRequestInmuebles');
const { requestConditions } = require('actions/mortgageRequest/mortgageRequestConditions');
const { validateHoldersData } = require('actions/mortgageRequest/mortgageHoldersDataValidation');

// @ constants
const {
    MORTGAGE_REQUEST_FETCH_DATA_PROPRIETOR_INFO,
    MORTGAGE_REQUEST_FETCH_DATA_PROPRIETOR_ECONOMIC,
    MORTGAGE_REQUEST_VIEW_PROCESS_FILE_REQUEST,
    MORTGAGE_REQUEST_VIEW_PROCESS_FILE_SUCESS,
    MORTGAGE_REQUEST_VIEW_PROCESS_FILE_FAILURE,
    MORTGAGE_REQUEST_VIEW_PROCESS_DATA_REQUEST,
    MORTGAGE_REQUEST_VIEW_PROCESS_DATA_SUCESS,
    MORTGAGE_REQUEST_VIEW_PROCESS_DATA_FAILURE
} = require('constants/actionTypes');

const fetchDataProprietorInfo = data => ({
    type: MORTGAGE_REQUEST_FETCH_DATA_PROPRIETOR_INFO,
    data
});

const fetchDataProprietorEconomic = data => ({
    type: MORTGAGE_REQUEST_FETCH_DATA_PROPRIETOR_ECONOMIC,
    data
});

const getEstatesData = (dispatch, getState) => {
    if (!getState().mortgageRequestEstates.get('ammountsRequested')) {
        fetchAmmounts()(dispatch);
    }
};

const fetchViewProcessFileInProgress = (isDownloading, isPrinting) => ({
    type: MORTGAGE_REQUEST_VIEW_PROCESS_FILE_REQUEST,
    data: {
        isDownloading,
        isPrinting
    }
});

const fetchViewProcessFileSuccess = dataBase64 => ({
    type: MORTGAGE_REQUEST_VIEW_PROCESS_FILE_SUCESS,
    file: {
        dataBase64
    }
});

const fetchViewProcessFileFailure = error => ({
    type: MORTGAGE_REQUEST_VIEW_PROCESS_FILE_FAILURE,
    file: {
        error
    }
});

const fetchViewProcessDataRequest = () => ({
    type: MORTGAGE_REQUEST_VIEW_PROCESS_DATA_REQUEST,
});

const fetchViewProcessDataSuccess = data => ({
    type: MORTGAGE_REQUEST_VIEW_PROCESS_DATA_SUCESS,
    data
});

const fetchViewProcessDataFailure = error => ({
    type: MORTGAGE_REQUEST_VIEW_PROCESS_DATA_FAILURE,
    data: { error }
});

const requestDataFileBase64 = (isDownloading = true, isPrinting = false) => dispatch => {
    dispatch(fetchViewProcessFileInProgress(isDownloading, isPrinting));

    const requestData = {
        query: {
            Idioma: getLanguage()
        }
    }
    return APIGet({
        dispatch,
        endpoint: 'mortgageRequestProcessViewBase64',
        params: requestData
    }).then(response => {
        dispatch(fetchViewProcessFileSuccess(response.data))
    })
        .catch(response => {
            if (!!response.error) {
                dispatch(fetchViewProcessFileFailure(response.error))
            } else {
                throw response
            }
        })
}

const getViewProcessData = (dispatch) => {
    dispatch(fetchViewProcessDataRequest());
    APIGet({
        dispatch,
        endpoint: 'mortgageRequestProcessViewData',
    })
        .then(response => {
            dispatch(fetchViewProcessDataSuccess(response.data))
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(fetchViewProcessDataFailure(response.error));
            } else {
                throw response;
            }
        });
}

const downloadDocument = (fileName, documentInfo) => {
    if (documentInfo) {
        const base64string = `data:${documentInfo.get('contentType')};base64,${documentInfo.get('base64')}`;
        const fileExtension = getExtension(documentInfo.get('contentType'));
        const fileType = documentInfo.get('contentType');

        downloadAsFile(base64ToBlob(base64string), fileType, `${fileName}.${fileExtension}`);
    }
}

const requestDownloadDocument = fileName => (dispatch, getState) => {
    const currentState = getState().mortgageRequestViewProcess;
    const documentInfo = currentState.get('file');
    const isPrinting = currentState.get('isPrinting');

    if (documentInfo) {
        downloadDocument(fileName, documentInfo);
    } else {
        requestDataFileBase64(true, isPrinting)(dispatch).then(() => {
            const documentInfo = getState().mortgageRequestViewProcess.get('file');
            downloadDocument(fileName, documentInfo)
        });
    }
}

const printDocument = documentInfo => {
    if (documentInfo) {
        let data = [];
        const base64string = `data:${documentInfo.get('contentType')};base64,${documentInfo.get('base64')}`;

        data.push(base64ToBlob(base64string));

        const blobObject = new Blob(data, { type: 'application/pdf' });

        if (BrowserUtils.browserIsIE()) {
            window.navigator.msSaveOrOpenBlob(blobObject);
        } else {
            const blobURL = window.URL.createObjectURL(blobObject);
            const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
                'resizable,screenX=50,screenY=50,width=850,height=1050';
            const printWindow = window.open(blobURL, '', winparams);
            printWindow.print();
        }
    }
}

const requestPrintDocument = () => (dispatch, getState) => {
    const currentState = getState().mortgageRequestViewProcess;
    const documentInfo = currentState.get('file');
    const isDownloading = currentState.get('isDownloading');

    if (documentInfo) {
        printDocument(documentInfo);
    } else {
        requestDataFileBase64(isDownloading, true)(dispatch).then(() => {
            const documentInfo = getState().mortgageRequestViewProcess.get('file');
            printDocument(documentInfo)
        });
    }
}

const requestData = (proprietorsList, typeRequest, dispatch) => {
    const data = proprietorsList.map(proprietor => {
        const tipoDocumentoIdentidad = get(proprietor, 'datosPersonales.documentoDeIdentidad.tipoDocumentoIdentidad');
        const numeroDocumento = get(proprietor, 'datosPersonales.documentoDeIdentidad.identificador');
        const requestData = {
            query: {
                tipoDocumentoIdentidad,
                numeroDocumento
            }
        };

        return new Promise((resolve) => {
            APIPost({
                dispatch,
                endpoint: typeRequest,
                params: requestData
            })
                .then(response => resolve(response))
                .catch(response => resolve({
                    success: false,
                    response
                }))
        });
    });
    return data;
}

const requestPersonalData = (dataProprietorsList, dispatch) => {
    const proprietorsList = get(dataProprietorsList, 'data', []); 
    const dataPersonalRequest = requestData(proprietorsList, 'mortgageRequestHolderInfo', dispatch);

    return Promise.all(dataPersonalRequest)
        .then((dataPersonal) => {
            const parsedDataPersonal = dataPersonal.map((dataPersonalProprietor) => {
                if (has(dataPersonalProprietor, 'data')) {
                    return get(dataPersonalProprietor, 'data');
                } else {
                    return {};
                }
            });

            dispatch(fetchDataProprietorInfo(parsedDataPersonal));
        })
};

const requestEconomicData = (dataProprietorsList, dispatch) => {
    const proprietorsList = get(dataProprietorsList, 'data', []);
    const dataEconomicRequest = requestData(proprietorsList, 'mortgageRequestHolderEconomic', dispatch);

    return Promise.all(dataEconomicRequest)
        .then((dataEconomic) => {
            const parsedDataEconomic = dataEconomic.map((dataEconomicProprietor) => {
                if (has(dataEconomicProprietor, 'data')) {
                    return get(dataEconomicProprietor, 'data');
                } else {
                    return {};
                }
            });

            dispatch(fetchDataProprietorEconomic(parsedDataEconomic));
        })
};

const promisesData = (dataProprietor, dispatch, getState) => {
    const promises = [
        requestPersonalData(dataProprietor.toJS(), dispatch),
        requestEconomicData(dataProprietor.toJS(), dispatch),
    ];

    Promise.all(promises).then(() => validateHoldersData(dispatch, getState));
}

const getHoldersPersonalAndEconomicData = (dispatch, getState, isInternalPage = false) => {
    const dataProprietor = getState().mortgageRequestDataProprietor;
    const {
        hasBeenFetched,
        hasBeenPersonalDataFetched,
        hasBeenPersonalEconomicFetched,
    } = dataProprietor.toJS();

    if (!isInternalPage || (isInternalPage && !hasBeenPersonalDataFetched && !hasBeenPersonalEconomicFetched)) {
        if (!hasBeenFetched) {
            const _requestDataProprietor = requestDataProprietor()(dispatch, getState);
            _requestDataProprietor.then(() => {
                const dataProprietorUpdated = getState().mortgageRequestDataProprietor;
                promisesData(dataProprietorUpdated, dispatch, getState);
            });
        } else {
            promisesData(dataProprietor, dispatch, getState);
        }
    }
};

const getSummaryDocumentationData = (dispatch, getState) => {
    if (!getState().mortgageRequestSummaryDocumentation.get('documentsRequested')) {
        const idExpediente = getState().mortgageRequestState.get('idExpediente');
        requestSummaryDocumentation(idExpediente)(dispatch, getState);
    }
};

const getInmueblesData = (dispatch, getState) => {
    if (!getState().mortgageRequestInmuebles.get('hasBeenFetched')) {
        requestInmuebles()(dispatch, getState);
    }
};

const getMortgageData = (dispatch, getState) => {
    const conditions = getState().mortgageRequestConditions.get('conditions');

    if (!getState().mortgageRequestConditions.get('isFetching') && conditions.get('idExpediente') === '') {
        requestConditions()(dispatch, getState);
    }
};

const getData = () => (dispatch, getState) => {
    getEstatesData(dispatch, getState);
    getSummaryDocumentationData(dispatch, getState);
    getInmueblesData(dispatch, getState);
    getMortgageData(dispatch, getState);
    getHoldersPersonalAndEconomicData(dispatch, getState);
    getViewProcessData(dispatch);
};

module.exports = {
    getData,
    getHoldersPersonalAndEconomicData,
    requestDownloadDocument,
    requestPrintDocument
}
